export const GUEST_AVATAR_URL = `https://storage.googleapis.com/deskbird-integration.appspot.com/users/guest_avatar.png`;
export const ANONYMOUS_USER_AVATAR_URL = `https://storage.googleapis.com/deskbird-integration.appspot.com/users/anonymous_user_avatar.png`;

export const ANONYMOUS_USER_NAME = "Anonymous user";
